var map = {
	"./deviant1.jpg": "343e",
	"./deviant2.jpg": "067a",
	"./dressing1.jpg": "4cf1",
	"./dressing2.jpg": "4523",
	"./dressing3.jpg": "d30a",
	"./furniture1.jpg": "1c8a",
	"./furniture2.jpg": "7855",
	"./furniture3.jpg": "90c2",
	"./hopium1.jpg": "42cc",
	"./hopium2.jpg": "dadf",
	"./hopium3.jpg": "5906",
	"./hotel1.jpg": "c663",
	"./hotel2.jpg": "3623",
	"./map1.jpg": "8007",
	"./map2.jpg": "9860",
	"./map3.jpg": "1dbf",
	"./map4.jpg": "2a27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "522e";